import Post3 from './Post3';

export default Post3;
